module.exports = __webpack_public_path__ + "static/media/tutorial_share_step@2x.025cfa2a.png";